import { TownPage } from "./town-page";

export default function Bellingham() {
  return (
    <TownPage
      town="Bellingham"
      path="/service-areas/bellingham"
      headline="Seasonal Care for Bellingham"
      description="TLC Associates LLC serves Bellingham's growing mix of established residential areas and newer developments. Classic New England neighborhoods and recently built subdivisions each have different landscape needs, from regular lawn maintenance and seasonal cleanups to renovation work. Bellingham properties benefit from a service plan that respects the existing character of the yard while keeping lawns, beds, shrubs, and walkways in order. Weekly lawn care supports the growing season, while pruning, garden work, and cleanup services address the details that change from spring through fall. When a property needs a broader reset, landscape renovation can bring the grounds back into a clear, usable layout."
    />
  );
}